import React, {useEffect, useState, useCallback} from 'react';
import {connect} from 'react-redux';
import {withRouter, useParams, Link} from 'react-router-dom';
import {Menu} from '../../utils/menu/Menu';
import {
  userDeleteAction,
  userEditAction,
  userGetAction,
  userStatusAction,
  uploadUserPhotoAction
} from '../../actions/usersAction';
import {formatErrors, roleNames, UPDATE_TOGGLE_MENU, validateEmail} from '../../constants';
import {toast} from 'react-toastify';
import {InputProfile} from "../../utils/input/InputProfile";
import {SelectProfile} from "../../utils/select/SelectProfile";
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {InputAvatar} from "../../utils/inputAvatar/InputAvatar";

const User = (props) => {
  const {user, getUserItem, showMenu} = props;
  const {id} = useParams();
  const [item, setItem] = useState(null);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);


  // get user
  const getUser = useCallback((id) => {
    getUserItem(id).then((data) => {
      setItem(data);
      setForm({
        id: id,
        email: data.email,
        password: '',
        last_name: data.last_name || '',
        first_name: data.first_name || '',
        patronymic_name: data.patronymic_name || '',
        phone: data.phone || '',
        role_id: data.role_id,
        status: data.status,
        number_active_chats: data.number_active_chats
      })
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [getUserItem]);

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm({...form, [name]: value});
    setErrors({...errors, [name]: name === 'email' && value.trim() === ''});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    if (form.email === '' || validateEmail(form.email) !== true) {
      errs.email = true;
    }

    if (form.first_name === '') {
      errs.first_name = true;
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    form.number_active_chats = form.number_active_chats*1
    form.role_id = form.role_id*1

    setLoading(true);
    props.editUserItem(form).then(() => {
      setLoading(false);
      getUser(id);
      toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });

  };

  const handleDelete = () => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.deleteUserItem(id).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Пользователь удален', {position: toast.POSITION.BOTTOM_RIGHT});
        props.history.push('/users');
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleBlockUser = (block) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.statusUserItem(id, block).then(() => {
        setLoading(false);
        resolve(true);
        getUser(id);
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  const handleImageChanged = (photo) => {
    setItem({...item, photo});
  };

  useEffect(() => {
    if (id) {
      getUser(id);
    }
  }, [id, getUser]);

  useEffect(() => {
    showMenu();
  }, [showMenu]);

  return <div className="content">
    <Menu />

    <header className="header header--nav">
      <Link to={'/users'} className="header__link">Сотрудники</Link>
    </header>

    {form && <div className="profile">
      <form className="profile__wrapper" noValidate onSubmit={handleSubmit}>
        <span className="profile__heading">Профиль сотрудника</span>
        <InputAvatar id={id} image={item.photo} handleUpdate={props.uploadUserPhoto} handleChange={handleImageChanged}/>
        <h4 className="profile__name">{item.last_name} {item.first_name} {item.patronymic_name}</h4>

        {item.block_user && <div className="profile__line">
          <div className="profile__status profile__status--error">Нет доступа</div>
          {user.id !== item.id && <ConfirmModal trigger={<span className="profile__link link">Разблокировать</span>}
                                                triggerWrap={false}
                                                title={"Разблокировать пользователя?"}
                                                handleOk={() => handleBlockUser(false)}/>}
        </div>}
        {!item.block_user && <div className="profile__line">
          <div className="profile__status" style={{margin: '0 24px 0 0'}}>{roleNames[item.role_id - 1]}</div>
          {user.id !== item.id && <ConfirmModal trigger={<span className="profile__link link">Заблокировать</span>}
                                                triggerWrap={false}
                                                title={"Заблокировать пользователя?"}
                                                handleOk={() => handleBlockUser(true)}/>}
        </div>}

        <div className="profile__inner profile__inner--group">
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Фамилия"
                          name="last_name"
                          placeholder="Введите фамилию"
                          value={form.last_name}
                          error={errors.last_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="text"
                          title="Имя"
                          name="first_name"
                          placeholder="Введите имя"
                          value={form.first_name}
                          error={errors.first_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="text"
                          title="Отчество"
                          name="patronymic_name"
                          placeholder="Введите отчество"
                          value={form.patronymic_name}
                          error={errors.patronymic_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
          <div className="profile__wrap">
            <InputProfile type="email"
                          title="Эл. почта"
                          name="email"
                          placeholder="Введите эл. почту"
                          value={form.email}
                          error={errors.email || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
            <InputProfile type="text"
                          title="Пароль"
                          name="password"
                          placeholder="Введите новый пароль"
                          value={form.password}
                          error={errors.password || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Телефон"
                          name="phone"
                          placeholder="Введите телефон"
                          value={form.phone}
                          error={errors.phone || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
          <div className="profile__wrap">
            <SelectProfile title="Роль"
                          name="role_id"
                          value={form.role_id}
                          error={errors.role_id || false}
                          disabled={loading}
                          onChange={handleChangeForm}>
              <option value="0">Не выбрана</option>
              {
                roleNames.map((i, k) => {
                  return <option key={'role_id_' + k} value={k + 1}>{i}</option>;
                })
              }
            </SelectProfile>
            
            {/*<InputProfile type="text"
                          title="Кол-во клиентов у пользователя"
                          name="count_clients"
                          placeholder="0"
                          value={item.count_clients}
                          disabled={true}/>*/}
                          
            <InputProfile type="number"
                          title="Кол-во активных чатов"
                          name="number_active_chats"
                          placeholder="Введите кол-во"
                          value={form.number_active_chats}
                          error={errors.number_active_chats || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
        </div>

        <button className="profile__btn btn">Сохранить</button>
        {user.id !== item.id && <ConfirmModal trigger={<span className="profile__heading profile__heading--bottom modal__link">Удалить пользователя</span>}
                      title={"Удалить пользователя?"}
                      handleOk={handleDelete}/>}

      </form>
    </div>}
  </div>;
};

const mapStateToProps = (state) => ({
  user: state.user.profile
});

const mapDispatchToProps = (dispatch) => {
  return {
    getUserItem(id) {
      return dispatch(userGetAction(id));
    },
    deleteUserItem(id) {
      return dispatch(userDeleteAction(id));
    },
    statusUserItem(id, block) {
      return dispatch(userStatusAction(id, block));
    },
    editUserItem(item) {
      return dispatch(userEditAction(item));
    },
    uploadUserPhoto(id, file) {
      return dispatch(uploadUserPhotoAction(id, file));
    },
    showMenu() {
      dispatch({type: UPDATE_TOGGLE_MENU, menu: true})
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(User))
